import React from 'react';

import classnames from 'classnames';

import CircularProgressBar from '../../../../components/CircularProgressBar';
import style from './index.scss';

import ComparisonSection from './ComparisonSection';
import ClusterFeatures from './ClusterFeatures';
import AdditionalInformation from './AdditionalInformation';

class Explainability extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: {
        comparison: false,
        additionalInformation: true,
        selectedClusterFeature: null
      },
      showSelectedHits: false,
      selectedHits: []
    };
  }

  onToggleAdditionalInformationSection = () => {
    const {
      isCollapsed,
      isCollapsed: { additionalInformation }
    } = this.state;
    this.setState({
      isCollapsed: {
        ...isCollapsed,
        additionalInformation: !additionalInformation,
        comparison: true,
        selectedClusterFeature: null
      }
    });
  };

  onToggleClusterFeatureSection = (clusterFeatureIndex) => {
    const {
      isCollapsed: { selectedClusterFeature }
    } = this.state;
    this.setState({
      ...this.state,
      isCollapsed: {
        comparison: true,
        additionalInformation: true,
        selectedClusterFeature:
          selectedClusterFeature === clusterFeatureIndex
            ? null
            : clusterFeatureIndex
      }
    });
  };

  onToggleComparisonSection = () => {
    const {
      isCollapsed,
      isCollapsed: { comparison }
    } = this.state;
    this.setState({
      isCollapsed: {
        ...isCollapsed,
        comparison: !comparison,
        additionalInformation: true,
        selectedClusterFeature: null
      }
    });
  };

  onToggleHitSelection = (toggledHit) => {
    const { selectedHits, onHitSelection } = this.props;
    const updatedSelectedHits = [];

    let isSelected = false;
    selectedHits.map((currentHit) => {
      // loop and see if the selectedHit is already selected
      if (JSON.stringify(currentHit) === JSON.stringify(toggledHit)) {
        isSelected = true;
      } else {
        updatedSelectedHits.push(currentHit);
      }
    });

    if (!isSelected) {
      updatedSelectedHits.push(toggledHit);
    }

    if (onHitSelection) {
      onHitSelection(updatedSelectedHits);
    }
  };

  onToggleShowSelectedHits = () => {
    const { showSelectedHits, selectedHits, onShowSelectedHits } = this.props;

    if (onShowSelectedHits) {
      onShowSelectedHits(!showSelectedHits);
    }
  };

  renderHitsHeader = () => {
    const { data, showSelectedHits, selectedHits, selectedHitsOffset } =
      this.props;
    const formattedDataWithSelectedHits = {
      ...data,
      hits: paginateHits(selectedHits, 5, selectedHitsOffset + 1)
    };

    if (showSelectedHits && formattedDataWithSelectedHits) {
      const { hits = [] } = formattedDataWithSelectedHits;

      if (Array.isArray(hits) && hits.length > 0) {
        const renderedHitHeaders = [];
        hits.forEach((currentHit) => {
          let isSelected = false;
          selectedHits.map((currentSelectedHit) => {
            if (
              JSON.stringify(currentSelectedHit) === JSON.stringify(currentHit)
            ) {
              isSelected = true;
            }
          });

          const { hit } = currentHit;
          if (hit) {
            let colorValue = null;
            switch (hit.hitCategorisation) {
              case 'L1':
                colorValue = '#4CAF50';
                break;
              case 'L2':
                colorValue = '#ff934f';
                break;
              case 'L3':
                colorValue = '#E85252';
                break;
              default:
                colorValue = null;
                break;
            }
            renderedHitHeaders.push(
              <th className={style.hitHeader}>
                <p>
                  {/* uncomment for checkbox selection */}
                  {/* <input
                    checked={isSelected}
                    onChange={ () => this.onToggleHitSelection(currentHit) }
                    type="checkbox" /> */}
                  {hit.hitCategorisation}
                  <span className={style.scoreProgressbar}>
                    <CircularProgressBar
                      sqSize={50}
                      percentage={Number(hit.hitScore).toFixed(2)}
                      strokeFill={colorValue}
                    />
                  </span>
                </p>
                <p>WID - {hit.watchlistId}</p>
              </th>
            );
          }
        });

        return renderedHitHeaders;
      }

      return null;
    }

    if (data) {
      const { hits = [] } = data;

      if (Array.isArray(hits) && hits.length > 0) {
        const renderedHitHeaders = [];
        hits.forEach((currentHit) => {
          let isSelected = false;
          selectedHits.map((currentSelectedHit) => {
            if (
              JSON.stringify(currentSelectedHit) === JSON.stringify(currentHit)
            ) {
              isSelected = true;
            }
          });

          const { hit } = currentHit;
          if (hit) {
            let colorValue = null;
            switch (hit.hitCategorisation) {
              case 'L1':
                colorValue = '#4CAF50';
                break;
              case 'L2':
                colorValue = '#ff934f';
                break;
              case 'L3':
                colorValue = '#E85252';
                break;
              default:
                colorValue = null;
                break;
            }
            renderedHitHeaders.push(
              <th className={style.hitHeader}>
                <p>
                  {/* uncomment for checkbox selection */}
                  {/* <input
                    checked={isSelected}
                    onChange={ () => this.onToggleHitSelection(currentHit) }
                    type="checkbox" /> */}
                  {hit.hitCategorisation}
                  <span className={style.scoreProgressbar}>
                    <CircularProgressBar
                      sqSize={50}
                      percentage={Number(hit.hitScore).toFixed(2)}
                      strokeFill={colorValue}
                    />
                  </span>
                </p>
                <p>WID - {hit.watchlistId}</p>
              </th>
            );
          }
        });

        return renderedHitHeaders;
      }

      return null;
    }

    return null;
  };

  renderNavigationTabs = () => {
    const { data } = this.props;
    const {
      isCollapsed: { comparison, additionalInformation, selectedClusterFeature }
    } = this.state;
    if (data) {
      const { hits = [] } = data;

      if (Array.isArray(hits) && hits.length > 0) {
        // get first hit's cluster as basis for labels
        const clusterList = hits[0].clusters;
        const clusterNavigationItems = [];
        if (Array.isArray(clusterList) && clusterList.length > 0) {
          clusterList.forEach((currentCluster, currentClusterIndex) => {
            clusterNavigationItems.push(
              <li
                onClick={() =>
                  this.onToggleClusterFeatureSection(currentClusterIndex)
                }>
                <p
                  className={
                    selectedClusterFeature === currentClusterIndex
                      ? style.navigationSelected
                      : null
                  }>
                  {currentCluster.name}
                </p>
              </li>
            );
          });
        }

        return (
          <div className="row">
            <div className="col-sm-12">
              <div className={style.explainabilityNavigationBar}>
                <ul>
                  <li onClick={this.onToggleComparisonSection}>
                    <p
                      className={!comparison ? style.navigationSelected : null}>
                      Comparison Section
                    </p>
                  </li>
                  {clusterNavigationItems}
                  <li onClick={this.onToggleAdditionalInformationSection}>
                    <p
                      className={
                        !additionalInformation ? style.navigationSelected : null
                      }>
                      Additional Information
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      }
    }

    return null;
  };

  renderSelectedHitsToggle = () => {
    const { showSelectedHits } = this.props;
    return (
      <div className={style.hitsToggleContainer}>
        <div className="row">
          <div className="col-sm-3">
            <p className={classnames(style.hitsToggleLabel, 'text-right')}>
              Clear Selection
            </p>
          </div>
          <div className="col-sm-1">
            <label className={style.toggleHitsSwitch}>
              <input
                checked={showSelectedHits}
                onChange={this.onToggleShowSelectedHits}
                type="checkbox"
              />
              <span className={classnames(style.slider, style.round)}></span>
            </label>
          </div>
          <div className="col-sm-3">
            <p className={style.hitsToggleLabel}>View Selected</p>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      data,
      buId,
      children,
      showSelectedHits,
      selectedHits,
      selectedHitsOffset,
      onTogglePastHitsModal
    } = this.props;
    if (data) {
      const { alert = {} } = data;
      const { isCollapsed } = this.state;
      const formattedDataWithSelectedHits = {
        ...data,
        hits: paginateHits(selectedHits, 5, selectedHitsOffset + 1)
      };

      let colorValue = null;
      switch (alert.alertLevel) {
        case 'L1':
          colorValue = '#4CAF50';
          break;
        case 'L2':
          colorValue = '#ff934f';
          break;
        case 'L3':
          colorValue = '#E85252';
          break;
        default:
          colorValue = null;
          break;
      }

      return (
        <div className={style.explainabilityContainer}>
          {this.renderNavigationTabs()}

          <div className="row">
            <div className="col-sm-6">
              {/* Uncomment for checkbox selection */}
              {/* { this.renderSelectedHitsToggle() } */}
            </div>
            <div className="col-sm-6">{children}</div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table>
                <thead>
                  <tr>
                    <th>
                      <p>Hit Level/Hit Score</p>
                      <p style={{ margin: 0 }}>Customer ID - CID/</p>
                      <p style={{ margin: 0 }}>Watchlist ID - WID</p>
                    </th>

                    <th>
                      {/* <p>{ alert.alertLevel }
                          <span className={style.scoreProgressbar}>
                            <CircularProgressBar
                              sqSize={35}
                              percentage={Math.floor(alert.alertMaxHitScore)}
                              strokeFill={colorValue}
                              />
                          </span>
                        </p> */}
                      <p>CID - {alert.primaryPartyKey}</p>
                    </th>

                    {this.renderHitsHeader()}
                  </tr>
                </thead>

                <tbody>
                  <ComparisonSection
                    buId={buId}
                    isCollapsed={isCollapsed.comparison}
                    data={
                      showSelectedHits ? formattedDataWithSelectedHits : data
                    }
                    onToggleCollapseState={this.onToggleComparisonSection}
                    onTogglePastHitsModal={onTogglePastHitsModal}
                  />

                  <ClusterFeatures
                    data={
                      showSelectedHits ? formattedDataWithSelectedHits : data
                    }
                    collapsedIndex={isCollapsed.selectedClusterFeature}
                    onToggleCollapseState={this.onToggleClusterFeatureSection}
                  />

                  <AdditionalInformation
                    isCollapsed={isCollapsed.additionalInformation}
                    data={
                      showSelectedHits ? formattedDataWithSelectedHits : data
                    }
                    onToggleCollapseState={
                      this.onToggleAdditionalInformationSection
                    }
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

const paginateHits = (array, page_size, page_number) => {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
};

export default Explainability;
